// extracted by mini-css-extract-plugin
export default {"small":"nZl9At+LUT"};
    if(module.hot) {
      // 1650537987936
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  